import Vue from 'vue';
import Component from 'vue-class-component';
import EdPortalTasksComponent from '@/app/private/portal/components/ed-portal-tasks/ed-portal-tasks.component.vue'
import EdPortalGradesComponent from '@/app/private/portal/components/ed-portal-grades/ed-portal-grades.component.vue'

@Component({
  name: 'ed-portal-tools',
  components: {
    EdPortalTasks: () => import(/* EdPortalTasks */'../ed-portal-tasks/ed-portal-tasks.component.vue'),
    EdPortalGrades: () => import(/* EdPortalGrades */'../ed-portal-grades/ed-portal-grades.component.vue')
  }
})
export default class EdPortalToolsComponent extends Vue {

  public tabs = 0;
  public tabsOptionHeader = [];

  public tabsOptionContent = [
    { id: 0, component: EdPortalTasksComponent },
    { id: 1, component: EdPortalGradesComponent }
  ]

  created() {
    this.tabsOptionHeader = [
      { id: 0, label: this.$t('portal.tasks') as string, ariaControls: 'Task' },
      { id: 1, label: this.$t('portal.grades') as string, ariaControls: 'Grades' },
      { id: 2, label: 'IM', ariaControls: 'IM', disabled: true },
      { id: 3, label: 'Chat', ariaControls: 'Chat', disabled: true },
      { id: 4, label: 'Report Book', ariaControls: 'Report Book', disabled: true },
      { id: 5, label: 'Support', ariaControls: 'Support', disabled: true },
    ];
  }
}